/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FxIdApplicationStoreCreatePaymentHandlerEmbeddingType;
(function (FxIdApplicationStoreCreatePaymentHandlerEmbeddingType) {
    FxIdApplicationStoreCreatePaymentHandlerEmbeddingType[FxIdApplicationStoreCreatePaymentHandlerEmbeddingType["Redirect"] = 0] = "Redirect";
    FxIdApplicationStoreCreatePaymentHandlerEmbeddingType[FxIdApplicationStoreCreatePaymentHandlerEmbeddingType["Embed"] = 1] = "Embed";
    FxIdApplicationStoreCreatePaymentHandlerEmbeddingType[FxIdApplicationStoreCreatePaymentHandlerEmbeddingType["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdApplicationStoreCreatePaymentHandlerEmbeddingType || (FxIdApplicationStoreCreatePaymentHandlerEmbeddingType = {}));
export function instanceOfFxIdApplicationStoreCreatePaymentHandlerEmbeddingType(value) {
    for (const key in FxIdApplicationStoreCreatePaymentHandlerEmbeddingType) {
        if (Object.prototype.hasOwnProperty.call(FxIdApplicationStoreCreatePaymentHandlerEmbeddingType, key)) {
            if (FxIdApplicationStoreCreatePaymentHandlerEmbeddingType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdApplicationStoreCreatePaymentHandlerEmbeddingTypeFromJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerEmbeddingTypeFromJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerEmbeddingTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdApplicationStoreCreatePaymentHandlerEmbeddingTypeToJSON(value) {
    return value;
}
export function FxIdApplicationStoreCreatePaymentHandlerEmbeddingTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdApplicationStoreCreatePaymentHandlerEmbeddingType.js.map